import { Tabs } from '@superops/ui-design-system';
import { getTranslatedText } from '@nile/components';
import React, { useState } from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';

const WorkItemListPopupContainer = styled.div`
  width: 515px;
  height: 400px;
`;

// const authorisedTabs = [
//   {
//     id: '1',
//     content: 'Tickets',
//     moduleName: 'TICKET',
//     authorisation: ['tickets'],
//     placeholder: getTranslatedText(intl, 'app.common.search.in', {
//       name: getTranslatedText(intl, 'app.modules.workspace.ticket')
//     }),
//     FeatureNameInBackend: 'TICKETING'
//   },
//   {
//     id: '5',
//     content: 'Project',
//     moduleName: 'PROJECT',
//     authorisation: ['project'],
//     placeholder: getTranslatedText(intl, 'app.common.search.in', {
//       name: getTranslatedText(intl, 'app.modules.workspace.project')
//     }),
//     FeatureNameInBackend: 'PROJECT_MANAGEMENT'
//   }
// ];

const workItemTabs = ['TICKET', 'PROJECT'];

const WorkItemListPopup = (props) => {
  const { tabs } = props;
  const intl = useIntl();

  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabChange = (tab) => {
    setSelectedTab(tab);
  };

  return (
    <WorkItemListPopupContainer className="br10 white-bg">
      <Tabs
        tabs={tabs.filter((tab) => workItemTabs.includes(tab?.moduleName))}
        selected={selectedTab}
        onSelect={handleTabChange}
      >
        {props?.children}
      </Tabs>
    </WorkItemListPopupContainer>
  );
};

export default WorkItemListPopup;
